
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destination/[state]/[destination]/landmarks",
      function () {
        return require("private-next-pages/destination/[state]/[destination]/landmarks/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destination/[state]/[destination]/landmarks"])
      });
    }
  